const getFlattenText = (richtext: any) => {
  const htmlString = richtext;
  const tempElement = document.createElement("div");
  tempElement.innerHTML = htmlString;
  const extractedText = tempElement.textContent || tempElement.innerText;
  return extractedText;
};

export default getFlattenText;
